import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { OkrKeyResultCommentCreate } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    OkrKeyResultObjectProps,

    LoadAllOkrKeyResultComments,
    LoadOkrKeyResultCommentById,
    SaveOkrKeyResultComment,
    DeleteOkrKeyResultComment,

    setOkrKeyResultCommentList,
} from "client/store"
import {
    Loader,
    Comments,
    EditCommentType,
    SaveCommentType,
    DeleteCommentType,
} from "client/components"

import { KeyResultCommentListWrapper } from "client/pages/okr/styled"

const KeyResultComments = ({
    keyResult,
}: OkrKeyResultObjectProps) => {
    const commentList = useSelector((state: StoreType) => state.okrKeyResultComment.commentList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!keyResult) return

        setLoadState(PENDING)
        LoadAllOkrKeyResultComments(keyResult.id).then((comments) => {
            setLoadState(IDLE)
            dispatch(setOkrKeyResultCommentList(keyResult.id, comments))
        })
    }, [keyResult])

    const onEdit: EditCommentType = (activeComment, editCallback) => {
        LoadOkrKeyResultCommentById(activeComment.id)
        .then((res) => editCallback(res))
    }

    const onSave: SaveCommentType = (comment, attachments, saveCallback) => {
        const newCommentData: OkrKeyResultCommentCreate = {
            keyResultId: keyResult.id,
            comment: comment.comment,
            author: comment.author,
        }

        SaveOkrKeyResultComment(
            comment.id,
            newCommentData,
            attachments,
            lang,
        ).then((res) => {
            if (!res.validation) {
                LoadAllOkrKeyResultComments(keyResult.id).then((comments) => {
                    dispatch(setOkrKeyResultCommentList(keyResult.id, comments))
                    saveCallback(res.validation)
                })
            } else {
                saveCallback(res.validation)
            }
        })
    }

    const onDelete: DeleteCommentType = (activeComment, deleteCallback) => {
        DeleteOkrKeyResultComment(activeComment.id, keyResult.id).then((removedRows) => {
            if (removedRows === 1) {
                dispatch(setOkrKeyResultCommentList(keyResult.id, commentList[keyResult.id].filter((row) => row.id !== activeComment.id)))
                deleteCallback()
            }
        })
    }

    return (
        <KeyResultCommentListWrapper>
            {
                loadState === PENDING
                && <Loader />
            }

            <Comments
                comments={commentList[keyResult.id]}
                onEdit={onEdit}
                onSave={onSave}
                onDelete={onDelete}
            />
        </KeyResultCommentListWrapper>
    )
}
export default KeyResultComments
